export const shouldReloadCache = (key, maxHours) => {
    if (window.localStorage.getItem(key)) {
        const cache = JSON.parse(window.localStorage.getItem(key));
        const diffMilliseconds = Math.abs(Date.now() - cache?.cacheTime);
        const hours = diffMilliseconds / (1000 * 60 * 60);
        return hours >= maxHours || cache?.cacheTime === undefined;
    }
    return true
}